import { rejectCodes } from './constants';

export const FarmRiskType = {
  Fo1: 'FO1',
  Fo2: 'FO2',
  Fo3: 'FO3',
  Fo4: 'FO4',
  Fo6Scheduled: 'FO6Scheduled',
  Fo6Structures: 'FO6Structures',
  Fo6Unscheduled: 'FO6Unscheduled'
};

export const FarmScheduleCoverageType = {
  SPP: 'SPP',
  RELATED_PRIVATE_STRUCTURES: 'RELATED_PRIVATE_STRUCTURES',
  MINE_SUBSIDENCE_COVERAGE: 'MINE_SUBSIDENCE_COVERAGE',
  ANIMALS_4H_FFA: 'ANIMALS_4H_FFA',
  PEAK: 'PEAK',
  INCOME: 'INCOME'
};

export const EntityType = {
  Individual: 'Individual',
  Business: 'Business',
  Joint: 'Joint',
  Estate: 'Estate',
  Partnership: 'Partnership',
  Corporation: 'Corporation',
  LimitedLiabilityCompany: 'LimitedLiabilityCompany',
  Trust: 'Trust',
  Association: 'Association',
  NotForProfitOrganization: 'NotForProfitOrganization',
  SubchapterSCorporation: 'SubchapterSCorporation'
};

export const ScheduledFarmItemTypes = {
  COMBINES: '1',
  CUSTOM_FARM_MACHINERY: '2',
  DESCRIBED_MACHINERY: '3',
  GRAIN: '4',
  HAY: '5',
  IRRIGATION_EQUIPMENT: '6',
  LIVESTOCK: '7',
  MACHINERY_NOT_DESCRIBED: '8',
  OTHER_FARM_SUPPLIES: '9',
  PERSONAL_PROPERTY: '10',
  POULTRY_EXCLUDING_TURKEYS: '11',
  RENTED_OR_BORROWED_EQUIPMENT: '12',
  TURKEYS: '13'
};

export const FarmScheduleCoverageTypesByState = {
  IL: [
    FarmScheduleCoverageType.SPP,
    FarmScheduleCoverageType.MINE_SUBSIDENCE_COVERAGE,
    FarmScheduleCoverageType.RELATED_PRIVATE_STRUCTURES,
    FarmScheduleCoverageType.ANIMALS_4H_FFA,
    FarmScheduleCoverageType.PEAK,
    FarmScheduleCoverageType.INCOME
  ],
  MO: [FarmScheduleCoverageType.SPP, FarmScheduleCoverageType.RELATED_PRIVATE_STRUCTURES]
};

export const StructureCategory = {
  BarnsOutbuildings: 'BO',
  SilosGrainBins: 'SG',
  DwellingContents: 'DC',
  PoultryBuildings: 'PO',
  ConfinementBuildings: 'C',
  HoopBuildings: 'H',
  SolarPanels: 'SP',
  Fencing: 'F',
  PrivatePowerLightPoles: 'PL',
  TrailerContents: 'TC',
  WindmillsWindchargers: 'WW',
  WindmillsSteel: 'WS',
  RadioTv: 'RT'
};

export const farmSoftRejectCodes: number[] = [rejectCodes.VERISK_NO360];

export enum LiabilityType {
  Personal = 'P',
  Commercial = 'C'
}

export const InlandMarineTypes = {
  BoatDock: { id: 'boatDock', value: 'Boat Dock' },
  Boats: { id: 'boats', value: 'Boats' },
  CoinCollection: { id: 'coinCollection', value: 'Coin Collection' },
  FineArts: { id: 'fineArts', value: 'Fine Arts' },
  Furs: { id: 'furs', value: 'Furs' },
  GolfCarts: { id: 'golfCarts', value: 'Golf Carts' },
  GolfEquipment: { id: 'golfEquipment', value: 'Golf Equipment' },
  Guns: { id: 'guns', value: 'Guns' },
  Jewelry: { id: 'jewelry', value: 'Jewelry' },
  MiscellaneousProperty: { id: 'miscellaneousProperty', value: 'Miscellaneous Property' },
  MusicalInstruments: { id: 'musicalInstruments', value: 'Musical Instruments' },
  PersonalTools: { id: 'personalTools', value: 'Personal Tools' },
  Silverware: { id: 'silverware', value: 'Silverware' },
  SportingEquipment: { id: 'sportingEquipment', value: 'Sporting Equipment' },
  Tack: { id: 'tack', value: 'Tack' },
  UnmannedAircraft: { id: 'unmannedAircraft', value: 'Unmanned Aircraft Systems (Drones)' },
  Hardware: { id: 'hardware', value: 'Hardware' },
  Software: { id: 'software', value: 'Software' },
  ScheduledGlass: { id: 'scheduledGlass', value: 'Scheduled Glass' },
  LawnMowers: {
    id: 'lawnMowersGardenTractorsAndRelatedEquipment',
    value: 'Lawn Mowers, Garden Tractors, and Related Equipment'
  },
  Atv: { id: 'atvsAndRelatedEquipment', value: 'ATVs and Related Equipment' }
};
